import React from "react";
import Theme from '../../../theme.module.css';
import Style from './SystemIntegration.module.css';
import CallToAction from "../../callToAction/CallToAction";

export default function SystemIntegration({setModalOpen}) {

    return (
        <div>
            <div className={`${Theme.columns} animateColumns`}>
                <div className={Theme.textCont}>
                    <p>Properly integrating your organisation's systems and automating the associated processes drives growth, reduces cost, and increases efficiency.</p>
                    <br/>
                    <p>We're experts in integrating all types of business systems such as ERP, CRM, PIM, payments, shipping services, omnichannel sales, stock management and more.</p>
                </div>
                <div style={{textAlign: "center"}} className={Style.glowBackground}>
                    <img src={require('../../../assets/microservice-icon.svg').default} alt="microservice-icon" className={Style.microserviceIcon} />
                </div>
            </div>
            <div className="animateCallToAction">
                <CallToAction text="Find out how we can improve your business efficiency with integration and automation." setModalOpen={setModalOpen} />
            </div>
        </div>
    );
}